// removed by extract-text-webpack-plugin
module.exports = {"sectionImg":"_2cGdAAd4C8k8QWxlzYl67O","imgPrez":"_2Z4jN5OxLGKbffIa_RyTa2"};


//////////////////
// WEBPACK FOOTER
// ./work/animalz/styles.module.css
// module id = 595
// module chunks = 0